import { MessageType, type SocketMessage } from "~/types";

export function isSystemMessage(socketMessage: SocketMessage) {
  return socketMessage.content.msg_type === MessageType.SYSTEM;
}

export function isSystemOnlyMessage(socketMessage: SocketMessage) {
  return socketMessage.content.msg_type === MessageType.SYSTEM_ONLY;
}

export function transformMessage(message: SocketMessage) {
  switch (message.content.code) {
    case "ban_user": {
      message.content.message += new Date(
        message.content.expires,
      ).toLocaleString();
    }
  }
  return message;
}
